import { useTranslate } from "@refinedev/core";
import { Button, Flex, Skeleton } from "antd";
import { useState } from "react";
import { useProjectInstance } from "../hooks/useProjectInstance";
import { usePublishUnpublish } from "../hooks/usePublishUnpublish";
import { PaperPlaneTiltIcon } from "@phosphor-icons/react";

interface PublishButtonProps {
  projectId: string;
  instanceId: string;
  setWillPublish?: (willPublish: boolean) => void;
  disabled?: boolean;
}

export const PublishButton: React.FC<PublishButtonProps> = ({
  projectId,
  instanceId,
  setWillPublish,
  disabled,
}) => {
  const t = useTranslate();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const { isLoading: isUpdatingStatus, isLive } = useProjectInstance({
    projectId,
    instanceId,
  });

  const { publishUnpublish } = usePublishUnpublish(projectId, instanceId);

  const handleTogglePublish = async (): Promise<void> => {
    try {
      setSubmitting(true);
      await publishUnpublish();
    } catch (error) {
      console.error("Error updating settings:", error);
    } finally {
      setSubmitting(false);
    }
    setWillPublish(false);
  };

  const getButton = () => {
    const action = () => {
      if (isLive) {
        handleTogglePublish().catch((error) =>
          console.error("Error updating settings:", error)
        );
      } else {
        setWillPublish(true);
      }
    };

    return (
      <Button
        onClick={action}
        shape="round"
        size="middle"
        type={isLive ? "default" : "primary"}
        disabled={disabled}
        loading={submitting}
        style={{
          boxShadow: "none",
        }}
      >
        {isLive ? (
          t("media.components.ProjectVideo.unpublish")
        ) : (
          <Flex gap={"8px"}>
            <PaperPlaneTiltIcon size={20} />
            {t("media.components.ProjectVideo.share")}
          </Flex>
        )}
      </Button>
    );
  };

  return isUpdatingStatus ? (
    <Skeleton.Button active shape="round" style={{ minWidth: 100 }} />
  ) : (
    getButton()
  );
};
